import { observer } from 'mobx-react-lite';
import queryString from 'query-string';
import React, { useContext, useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { history } from '../..';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { LoginValues } from '../../app/models/login';
import { RootStoreContext } from '../../app/stores/rootStore';

const SKIYAKIAuth: React.FC<RouteComponentProps> = ({ location }) => {
  const rootStore = useContext(RootStoreContext);
  const { setSession, getSession } = rootStore.sessionStore;
  const { getSkiyakiAuth, loginSkiyakiAuth } = rootStore.memberStore;

  const { client_id, auth_params, callback_url, code, state } = queryString.parse(location.search);

  const formRef = useRef<any | null>(null);
  const inputClientIdRef = useRef<any | null>(null);
  const inputRedirectUriRef = useRef<any | null>(null);
  const inputResponseTypeRef = useRef<any | null>(null);
  const inputStateRef = useRef<any | null>(null);

  useEffect(() => {
    if (code && state) {
      // SKIYAKIからのコールバック呼び出し
      (async () => {
        try {
          // セッション取得
          const session = await getSession(state as string);
          // 認証先のパラメータを設定
          const values = new LoginValues();
          values.session_id = state as string;
          values.client_id = session.client_id;
          values.auth_params = session.auth_params;
          values.id = code as string;
          // 認証
          await loginSkiyakiAuth(values);
        } catch (error) {
          history.push('/error');
        }
      })();
    } else {
      // 初回呼び出し
      (async () => {
        try {
          // セッション保持
          const session = await setSession({
            session_id: '',
            client_id: client_id as string,
            auth_params: auth_params as string,
            callback_url: callback_url as string,
          });
          // SKIYAKI認証パラメータ作成API呼び出し
          const skiyaki = await getSkiyakiAuth(client_id as string, auth_params as string);
          // SKIYAKI認証にRedirect!!
          inputClientIdRef.current.name = 'client_id';
          inputClientIdRef.current.value = skiyaki.client_id;
          inputRedirectUriRef.current.name = 'redirect_uri';
          inputRedirectUriRef.current.value = skiyaki.redirect_uri;
          inputResponseTypeRef.current.name = 'response_type';
          inputResponseTypeRef.current.value = skiyaki.response_type;
          inputStateRef.current.name = 'state';
          inputStateRef.current.value = session.session_id;
          formRef.current.action = skiyaki.target_url;
          formRef.current.method = 'GET';
          formRef.current.submit();
        } catch (error) {
          history.push('/error');
        }
      })();
    }
  }, [auth_params, callback_url, client_id, code, state, getSession, getSkiyakiAuth, loginSkiyakiAuth, setSession]);

  return (
    <form ref={formRef}>
      <input type="hidden" ref={inputClientIdRef} />
      <input type="hidden" ref={inputRedirectUriRef} />
      <input type="hidden" ref={inputResponseTypeRef} />
      <input type="hidden" ref={inputStateRef} />
      <LoadingComponent content="Redirecting..." />
    </form>
  );
};

export default observer(SKIYAKIAuth);
